<template>
    <span @click="addAuctionToQuery(auction.id)">{{ auction.name }} <input type="checkbox" v-model="isActive" /></span>
</template>
<script>
    export default {
        props: ['auction', 'region'],
        methods: {
            addAuctionToQuery: function (auctionId) {
                if ( this.$store.getters.getQueryAuctionById(auctionId).length === 0 ) {
                    this.$store.dispatch('addAuctionToQuery', auctionId)
                } else {
                    this.$store.dispatch('removeAuctionFromQuery', auctionId)
                }
            }
        },
        computed: {
            isActive: {
                get: function () {
                    return this.$store.getters.getQueryAuctionById(this.auction.id).length !== 0
                },
                set: function (value) {

                }
            }
        }
    }
</script>

<style scoped>
    span {
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Auction.vue